<template>
    <v-snackbar
        top
        auto-height
        :timeout="timeout"
        v-model="show"
        :color="color"
    >
        {{ message }}
        <v-btn
            icon
            @click="show = false"
        >
            <v-icon size="16">
                fas fa-times
            </v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
import SnackBus from '../utils/buses/snackBus'

export default {
    data () {
        return {
            show: false,
            message: null,
            color: null,
            timeout: 5000
        }
    },
    created () {
        SnackBus.$on('message-sent', this.showMessage)
    },
    beforeDestroy () {
        // remove event listener to avoid memory leaks
        SnackBus.$off('message-sent', this.showMessage)
    },
    methods: {
        showMessage (message, color) {
            this.message = message
            this.show = true
            this.color = color
        }
    }
}
</script>

<style>

</style>
